import { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import { createEditorInstanceImperativeHandle, useMergeForcedTextValue } from 'src/lib/slate';

import { CustomSlate } from '../CustomSlate';

export const RichSlateHost = forwardRef(
  ({ editor, initialValue, forcedTextValue, onChange, children }, ref) => {
    useImperativeHandle(ref, () => createEditorInstanceImperativeHandle(editor), [editor]);

    // If `forcedTextValue` is provided or changed, then whole editor value will be replaced with it
    useMergeForcedTextValue(editor, forcedTextValue);

    return (
      <CustomSlate
        editor={editor}
        initialValue={initialValue}
        onValueChange={onChange}
      >
        {children}
      </CustomSlate>
    );
  }
);

RichSlateHost.propTypes = {
  editor: PropTypes.shape().isRequired,
  initialValue: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  forcedTextValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

RichSlateHost.defaultProps = {
  forcedTextValue: null,
};
